import React from 'react';
import './BrandSplash.css';
export default function BrandSplash() {
  return <div className="cc-brand-splash" role="status" aria-label="Opening CaterCTRL">
    <img src={`${process.env.PUBLIC_URL || ''}/brand/caterctrl-splash-logo.svg`} alt="" />
  </div>;
}
